import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { concat, merge, of, tap, from, Subscription, Subject } from 'rxjs';
import { map, concatMap, switchMap, finalize, distinctUntilChanged, debounceTime, filter } from 'rxjs/operators';
import { FilterService } from 'primeng/api';
import { Table } from 'primeng/table';

import { environment } from 'src/environments/environment';
import { Document } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ClientApiService } from 'src/app/services/client-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { Client } from '../../shared/client';

/*
ci_custid	ci_orderid	ci_odate	ci_onumber	ci_comment1	ci_comment2	ci_ordsum	ci_paysum	ci_paydate	ci_shipsum	ci_mansum	ci_rsrsum	ci_waysum	ci_details
1377	96823	2022-04-26 12:09:04.177	14618			21868,2	21868,2	2022-04-29 15:19:03.133	21868,2	0	0	0
1377	99025	2022-11-01 13:46:42.517	15857	-10%  НЕ хватает доходности для учетки		15181,68	15181,68	2022-11-11 12:20:14.277	15181,68	0	0	0
1377	99962	2022-12-28 22:52:54.133	16546	-10%  НЕ хватает доходности для учетки		109072,2	109072,2	2023-01-03 19:22:48.373	109072,2	0	0	0
*/
@Component({
  selector: 'app-list-client-balance-due',
  templateUrl: './list-client-balance-due.component.html',
  styleUrls: ['./list-client-balance-due.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListClientBalanceDueComponent implements OnInit, OnDestroy, OnChanges {
  @Input() document: Document;

  @Input() clientId: number = 0;
  mainClientId: number = 0;
  client: Client = null;

  gs: GlobalSettingsData;

  recordsList: any[] = [];
  selectedRecord: any;

  totalRecords: number = 0;

  today: Date;

  totalOrders: number = 0;
  totalShipped: number = 0;
  totalPayd: number = 0;
  totalReserved: number = 0;
  totalManufacture: number = 0;
  totalOnTheWay: number = 0;

  loading: boolean = false;

  private recordsQuery: Subscription = null;

  balanceQuery$: Subject<{ cliid: number, depth: number }> = new Subject();

  depth: number = 12; // 12 month depth by default (not used so far)

  @ViewChild('ptable1') ptable1: Table;

  cf1: any = {};    // to store f[string] filters value

  constructor(
    private docApi: DocumentApiService,
    private cliApi: ClientApiService,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** ListDocumentPaymentsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      switch (propName) {

        case 'clientId':
          this.balanceQuery$.next({ cliid: change.currentValue, depth: this.depth });
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** ListDocumentPaymentsComponent in ngOnDestroy");

    if (this.recordsQuery) { this.recordsQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log("*** ListDocumentPaymentsComponent in ngOnInit");

    this.today = new Date();

    console.log('*** Home in onInit: ' + JSON.stringify(this.today));

    this.gs = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.balanceQuery$
      .pipe(
        debounceTime(100),
        filter(cliid => (cliid !== null)),
        distinctUntilChanged(),

        switchMap(opt => this.cliApi.getMainIdByClientId(opt.cliid).pipe(
          filter(cli => (cli.length > 0)),
          map(cli => {
            this.loading = true;
            this.client = cli[0];
            this.mainClientId = this.client.CLIID;
            return (opt);
            }))
        ),
        concatMap(opt => this.cliApi.getClientBalanceDue(
          this.mainClientId,
          this.gs.mainCompanyId,
          this.gs.balanceCurrencyId,
          this.gs.mainStockId,
          this.gs.impStockId,
          this.gs.auxStockId,
          this.gs.manDepartmentId, new Date()).pipe(
            map(data => {
              this.recordsList = data.sort((a, b) => (a.ci_odate < b.ci_odate ? 1 : 0));
              environment.production || console.table(this.recordsList);
              this.totalRecords = this.recordsList.length;
            }),

            finalize(() => {

              this.totalOrders = this.recordsList.reduce((r, s) => r + s.ci_ordsum, 0);
              this.totalPayd = this.recordsList.reduce((r, s) => r + s.ci_paysum, 0);
              this.totalShipped = this.recordsList.reduce((r, s) => r + s.ci_shipsum, 0);
              this.totalReserved = this.recordsList.reduce((r, s) => r + s.ci_rsrsum, 0);
              this.totalOnTheWay = this.recordsList.reduce((r, s) => r + s.ci_waysum, 0);
              this.totalManufacture = this.recordsList.reduce((r, s) => r + s.ci_mansum, 0);

              this.loading = false;
            })
          ))
      )
      .subscribe();

    this.balanceQuery$.next({ cliid: this.clientId, depth: this.depth });
  }
  /*
    ci_comment1 : ""
    ci_comment2 : ""
    ci_custid : 1377
    ci_details : ""
    ci_mansum : 0
    ci_odate : "2018-07-24T12:09:26.000Z"
    ci_onumber : "15201"
    ci_orderid : 74015
    ci_ordsum : 5948.25
    ci_paydate : "2018-08-06T09:32:21.000Z"
    ci_paysum : 5948.25
    ci_rsrsum : 0
    ci_shipsum : 5948.25
    ci_waysum : 0
 */

  onChangeRecentOrdersType(event) {
    console.log('*** ListDocumentPaymentsComponent in onChangeRecentOrdersType');
  }

  onRecentRowSelect(event) {
  }

  onStateSave(state) {
    console.log('*** ListDocumentPaymentsComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestoreNew(state) {
    console.log('*** ListDocumentPaymentsComponent onStateRestoreNew: ' + JSON.stringify(state));
    if (state.filters) {
      for (let f in state.filters) {
        let fltItem = state.filters[f];
        this.cf1[f] = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;
      }
    }
  }

  clearSavedSettings() {
    console.log('*** ListDocumentPaymentsComponent in clearSavedSettings: ');
    try {
      this.ptable1.clearState();
    } catch (e) {
      console.log('*** ListDocumentPaymentsComponent in clearSavedSettings: ' + JSON.stringify(e));
    }
  }
}

